import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import { useSEO } from "@/hooks/useSEO";

const team = [
  { name: "内容运营组", role: "内容与版权", icon: "ri-film-line" },
  { name: "产品技术组", role: "产品与技术", icon: "ri-code-s-slash-line" },
  { name: "用户服务组", role: "客服与社区", icon: "ri-customer-service-2-line" },
  { name: "视觉设计组", role: "设计与体验", icon: "ri-palette-line" },
];

const values = [
  { icon: "ri-shield-check-line", title: "正版优先", desc: "坚持正版内容合作，为用户提供安心、合规的观看环境。" },
  { icon: "ri-rocket-2-line", title: "体验至上", desc: "持续打磨播放与浏览体验，让找片、看片都更流畅。" },
  { icon: "ri-community-line", title: "开放分享", desc: "鼓励用户分享优质内容，让好作品被更多人看见。" },
];

export default function About() {
  useSEO({
    title: "关于我们 - 桔子视频",
    description: "桔子视频专注于正版影视资源的在线播放与视频分享，了解我们的使命、团队与版权声明。",
    keywords: "桔子视频,关于我们,正版影视,版权声明,团队介绍",
  });

  return (
    <Layout>
      <section className="border-b border-background-200 bg-background-100/70">
        <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
            <i className="ri-information-line" />
            关于我们
          </span>
          <h1 className="mt-4 max-w-3xl text-2xl font-bold text-foreground-950 md:text-4xl font-heading">
            让每一次观看，都值得被认真对待
          </h1>
          <p className="mt-4 max-w-3xl text-sm leading-relaxed text-foreground-700 md:text-base">
            桔子视频是一个专注于正版影视资源的在线播放与视频分享平台。我们汇聚电影、电视剧、综艺、动漫、纪录片等多类别优质内容，致力于为广大影视爱好者提供便捷的查找体验、流畅的观看体验，以及自由分享与发现的社区氛围。
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <h2 className="text-xl font-bold text-foreground-950 md:text-2xl font-heading">我们的使命</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              我们相信，好的影视内容能够跨越时间与距离，带给人感动、思考与陪伴。桔子视频希望通过专业的正版内容运营和出色的产品体验，成为每一位观众随身的视听伙伴。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              从选片、播放到分享互动，我们不断优化每一个环节，让用户能够更轻松地发现喜欢的作品，也更愿意把自己的热爱分享给更多人。
            </p>

            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-3">
              {values.map((value) => (
                <div key={value.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-lg text-accent-700">
                    <i className={value.icon} />
                  </span>
                  <h3 className="mt-3 text-base font-semibold text-foreground-950">{value.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-500">{value.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="space-y-4">
            <div className="rounded-lg bg-primary-500 p-6 text-background-50">
              <p className="text-3xl font-bold font-heading">5000+</p>
              <p className="mt-1 text-sm text-background-100">正版影视内容</p>
            </div>
            <div className="rounded-lg border border-background-200 bg-background-50 p-6">
              <p className="text-3xl font-bold text-foreground-950 font-heading">200万+</p>
              <p className="mt-1 text-sm text-foreground-500">日活跃观众</p>
            </div>
            <div className="rounded-lg border border-background-200 bg-background-50 p-6">
              <p className="text-3xl font-bold text-foreground-950 font-heading">30+</p>
              <p className="mt-1 text-sm text-foreground-500">正版内容合作伙伴</p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-background-100/70 py-12 md:py-16">
        <div className="mx-auto max-w-[1280px] px-4 md:px-6">
          <h2 className="text-xl font-bold text-foreground-950 md:text-2xl font-heading">团队介绍</h2>
          <p className="mt-1 text-sm text-foreground-500">一群热爱影视、专注体验的伙伴</p>
          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {team.map((member) => (
              <div key={member.name} className="rounded-lg border border-background-200 bg-background-50 p-5 text-center">
                <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-xl text-primary-600">
                  <i className={member.icon} />
                </span>
                <h3 className="mt-3 text-base font-semibold text-foreground-950">{member.name}</h3>
                <p className="mt-1 text-xs text-foreground-500">{member.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
            <h2 className="text-xl font-bold text-foreground-950 font-heading">联系我们</h2>
            <p className="mt-2 text-sm text-foreground-500">期待听到你的声音</p>
            <ul className="mt-5 space-y-4 text-sm">
              <li className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                  <i className="ri-mail-line" />
                </span>
                <span className="text-foreground-800">support@juzivideo.com</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                  <i className="ri-phone-line" />
                </span>
                <span className="text-foreground-800">400-800-6688</span>
              </li>
              <li className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                  <i className="ri-map-pin-line" />
                </span>
                <span className="text-foreground-800">北京市朝阳区影视产业园 A 座</span>
              </li>
            </ul>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
            <h2 className="text-xl font-bold text-foreground-950 font-heading">版权声明</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              桔子视频尊重并保护知识产权，平台内容均以正版合作为方向进行运营。本站为演示平台，所有影视名称、简介、图片与数据均为示例展示，不构成真实内容服务。若涉及版权问题，请通过上述联系方式与我们取得联系，我们将及时处理。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-home-4-line text-base" />
                返回首页
              </Link>
              <Link
                to="/share-intro"
                className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
              >
                了解视频分享
              </Link>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}